import { formatPrice } from '../../../utils/formats';

/**
 * Returns an object describing ticket prices, given a races array.
 */
export default (races = []) => {
  let currencyLabel = '';

  const prices = [].concat(
    ...races.filter(r => !!r.tickets).map((r) => {
      currencyLabel = r.tickets.currencyLabel; // Assumed to always be identical
      return r.tickets.tickets
        .filter(t => t.charityTickets !== true)
        .map(t => t.discountPrice || t.rrp);
    }),
  );

  if (prices.length > 0) {
    const multiplePrices = [...new Set(prices)].length > 1;
    const pricesFrom = Math.min(...prices);
    const pricesTo = Math.max(...prices);

    return {
      fromFormatted: formatPrice(currencyLabel, pricesFrom),
      ...(multiplePrices && {
        toFormatted: formatPrice(currencyLabel, pricesTo),
      }),
    };
  }

  return null;
};



// WEBPACK FOOTER //
// ./app/src/components/RaceSummary/helpers/getTicketPrices.js